module.exports = __webpack_public_path__ + "assets/normal/images/Empty_2.9be81132.png";